import get from 'lodash/get';
import max from 'lodash/max';

import { SYSTEM_CHANNEL } from '../../../constants/chat';

const connectToChatData = (apiCircles, chatChannels) =>
  apiCircles.map(item => {
    const contextChannels = get(item, 'subchannels');
    const contextChannel = get(item, 'contextChannel');

    // handle context / social chats differences
    const channels = contextChannels || [contextChannel].filter(Boolean);

    const channelData = channels.reduce(
      (acc, channel) => {
        const { type, channelId, lastMessageAt, totalUnreadCount } = channel;

        const channelUnreads = get(
          chatChannels,
          [channelId, 'unreadCount'],
          totalUnreadCount,
        );
        const channelLastMessageAt =
          get(chatChannels, [channelId, 'lastMessageAt']) || lastMessageAt;

        acc.unreadCount += channelUnreads;

        if (type !== SYSTEM_CHANNEL) {
          acc.lastMessageAt = max([acc.lastMessageAt, channelLastMessageAt]);
        }

        return acc;
      },
      {
        unreadCount: 0,
        lastMessageAt: null,
      },
    );

    return {
      ...item,
      ...channelData,
    };
  });

export default connectToChatData;



// WEBPACK FOOTER //
// ./src/redux/board/helpers/connectToChatData.js